import { render } from "./orderManage.vue?vue&type=template&id=57268eca&scoped=true"
const script = {}

import "./orderManage.vue?vue&type=style&index=0&id=57268eca&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57268eca"]])

export default __exports__